const previewProfile = {
  user_guid: "preview-user-guid",
  member_id: "CLARINS-0001",
  member_level_id: 1,
  member_list: [
    {
      id: 1,
      is_default: 1,
      display_name: "Gold",
      member_level_language: [{ display: "Gold" }],
      upgrade_tier_id: 0,
      upgrade_baht: 50000,
      maintain_baht: 30000
    }
  ],
  display: "Gold",
  first_name_th: "Preview",
  last_name_th: "Member",
  first_name_en: "Preview",
  last_name_en: "Member",
  telephone: "0812345678",
  email: "preview@example.com",
  total_point: 12500,
  current_accumulated_amount: 18000,
  balance_to_upgrade: 12000,
  point_expired: 250,
  point_expired_date: "2026-12-31",
  picture: "",
  login_type: 1
};

const previewLabels = [
  { id: 1, name: "th", image_url: "", sort_order: 1 },
  { id: 2, name: "en", image_url: "", sort_order: 2 }
];

const previewLabelValues = [
  { label_id: 1, label_name: "news", name: "News" },
  { label_id: 2, label_name: "all", name: "All" },
  { label_id: 3, label_name: "collect_point", name: "Collect Point" },
  { label_id: 4, label_name: "point_expired", name: "Point Expired" },
  { label_id: 5, label_name: "currency_unit", name: "Points" },
  { label_id: 6, label_name: "earn_channel", name: "Earn Channel" },
  { label_id: 7, label_name: "add", name: "Add" },
  { label_id: 8, label_name: "profile", name: "Profile" },
  { label_id: 9, label_name: "privilege", name: "Privilege" },
  { label_id: 10, label_name: "setting", name: "Setting" },
  { label_id: 11, label_name: "logout", name: "Logout" },
  { label_id: 12, label_name: "confirm_logout", name: "Confirm logout?" },
  { label_id: 13, label_name: "complate_profile", name: "Profile Complete" },
  { label_id: 14, label_name: "minimal_profile_tab_title", name: "MY ACCOUNT" },
  { label_id: 15, label_name: "loading", name: "Loading" }
];

export const previewBaseConfig = {
  brand_name: "Clarins",
  memberLiffUrl: "",
  member_url: "",
  custom_js: "",
  custom_font: "",
  custom_font_bold: "",
  font_size: "Normal",
  font_size_detail: [],
  isLoginLine: false,
  socialProvider: "preview",
  socialID: "preview-user",
  line_layout: "Compact",
  progress_display: 0,
  display_profile_complete: "1",
  customer_display_transaction_detail: "1",
  line_display_point_channel: "1",
  display_connect_channel: "1",
  line_display_member_level: "1",
  line_display_service_outstanding: "1",
  line_display_logout_button: "1",
  line_display_code_countdown: "1",
  line_display_right_request_link: "1",
  line_display_redeem_expire: "1",
  display_point_after_redeem: "1",
  display_upcomming_redeem: "1",
  display_reward_progress: "1",
  display_point_expired: "1",
  line_display_mission: "1",
  display_highlight_connect_channel: "1",
  display_email_login: "1",
  show_current_accumulated_amount: "1",
  show_balance_to_upgrade: "1",
  line_display_setting_button: "1",
  display_edit_profile: "1",
  display_telephone_country: "1",
  year_format: 2
};

export const previewThemeResponse = {
  result: {
    ...previewBaseConfig,
    is_custom_privacy_link: "0",
    is_center_point: "1",
    consent_url_link: "",
    is_right_request_url: "0",
    right_request_url: "",
    is_term_and_con_url: "0",
    term_and_con_url: "",
    themeBackGround: "#ffffff",
    themeBackgroundPage: "#f6f6f6",
    themeDisableColor: "#e5e5e5",
    themeLightPrimaryColor: "#f6e7e9",
    themeLogoHomePage: "",
    themeLogoLine: "",
    themeLogoLoginPage: "",
    themePrimaryColor: "#b68a8f",
    themePrintLogo: "",
    themeSecondaryColor: "#222222",
    themeSolidColor: "#b68a8f",
    themeTransactionCodeBanner: "",
    themeTransactionCodeEarn: "",
    themeTransactionCodeError: "",
    point_logo: "",
    profile_complete_description: "Preview profile completion"
  },
  themeLogoDomain: ""
};

const previewMarketPlace = {
  marketplace: [
    {
      id: 1,
      branchId: 1,
      shopName: "LINE",
      marketplaceUrl:
        "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
      status: true
    },
    {
      id: 2,
      branchId: 2,
      shopName: "Marketplace",
      marketplaceUrl:
        "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
      status: true
    }
  ]
};

const previewNewsList = [
  {
    id: 1,
    name: "Preview News",
    short_description: "Mock content for LINE profile preview.",
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    is_video: 0
  },
  {
    id: 2,
    name: "New Promotion",
    short_description: "Promotion preview item from admin settings.",
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    is_video: 0
  },
  {
    id: 3,
    name: "Member Privilege",
    short_description: "Sample privilege card for iframe preview.",
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    is_video: 0
  }
];

const previewBannerList = [
  {
    id: 1,
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    redirect_url: "",
    name: "Preview Banner"
  }
];

export function isPreviewMode() {
  return new URLSearchParams(window.location.search).get("preview") === "1";
}

export function getPreviewConfig() {
  const value = new URLSearchParams(window.location.search).get(
    "preview_config"
  );

  if (!value) return {};

  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Invalid preview_config", error);
    return {};
  }
}

export function applyPreviewConfig(config, themeResponse) {
  const previewConfig = getPreviewConfig();

  Object.assign(config, previewConfig, {
    isLoginLine: false,
    socialProvider: "preview",
    socialID: "preview-user"
  });

  if (themeResponse?.result) {
    themeResponse.result = {
      ...themeResponse.result,
      ...previewConfig
    };
  }
}

export function createPreviewConfig() {
  return {
    ...previewBaseConfig,
    ...getPreviewConfig()
  };
}

export function createPreviewThemeResponse() {
  const previewConfig = getPreviewConfig();

  return {
    ...previewThemeResponse,
    result: {
      ...previewThemeResponse.result,
      ...previewConfig
    }
  };
}

export function seedPreviewStore(store) {
  store.commit("setShortProfile", previewProfile);
  store.commit("setCloneProfile", previewProfile);
  store.commit("setCompleteProfile", {
    detail: {
      profile: 80
    }
  });
  store.commit("setAuthen", true);
  store.commit("setIsMemberBypass", 1);
  store.commit("setIsUser", {
    status: 1,
    provider: {
      userId: "preview-user",
      displayName: "Preview Member",
      pictureUrl: ""
    }
  });
}

export function getPreviewResponse(config) {
  const url = config?.url || "";

  if (url.includes("/api/v1/user/GetUserProfile")) {
    return {
      result: 1,
      detail: previewProfile
    };
  }

  if (url.includes("/api/v1/setting/display_language/label/")) {
    return {
      result: 1,
      detail: previewLabelValues
    };
  }

  if (url.includes("/api/v1/setting/display_language")) {
    return {
      result: 1,
      detail: previewLabels
    };
  }

  if (url.includes("/api/v1/User/GetCompleteProfile")) {
    return {
      result: 1,
      detail: {
        profile: 80
      }
    };
  }

  if (url.includes("/api/v1/MonthlyPrivilege/list")) {
    return {
      result: 1,
      detail: {
        totalCount: previewNewsList.length,
        detail: previewNewsList
      }
    };
  }

  if (url.includes("/api/v1/banner/campaign_form")) {
    return {
      result: 1,
      detail: {
        totalCount: previewBannerList.length,
        detail: previewBannerList
      }
    };
  }

  if (url.includes("/api/v1/User/get/marketplace")) {
    return {
      result: 1,
      detail: previewMarketPlace
    };
  }

  if (url.includes("/api/v1/FriendGetFriend/get")) {
    return {
      result: 1,
      detail: []
    };
  }

  if (url.includes("/api/v1/setting/display_language/customer_menu")) {
    return {
      result: 1,
      detail: [
        {
          id: 1,
          display: 1,
          name: "Rewards",
          menu_url: "/reward"
        },
        {
          id: 2,
          display: 1,
          name: "Purchase History",
          menu_url: "/transaction-summary"
        }
      ]
    };
  }

  if (url.includes("/api/v1/setting/customlink/list")) {
    return {
      result: 1,
      detail: []
    };
  }

  if (url.includes("/api/CustomObject/custom_object_register_page")) {
    return {
      result: 1,
      detail: []
    };
  }

  return null;
}
